module.exports = __webpack_public_path__ + "static/BebasKai-d2ec18c1fe5dbd82eee76078cc5558e1.woff2";